import { render, staticRenderFns } from "./sunset_timesheet_activity_widget.vue?vue&type=template&id=4e7f2076&scoped=true"
import script from "./sunset_timesheet_activity_widget.vue?vue&type=script&lang=js"
export * from "./sunset_timesheet_activity_widget.vue?vue&type=script&lang=js"
import style0 from "./sunset_timesheet_activity_widget.vue?vue&type=style&index=0&id=4e7f2076&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7f2076",
  null
  
)

export default component.exports